/* Coil footer — always as tall as the viewport minus the site header, on every
 * page. Scrolled to the bottom, the footer fills the whole screen below the
 * sticky menu. (The newsletter that used to sit above it is disabled, so this
 * is just "fill the screen below the header" — no above-footer measurement.)
 * Falls back to the CSS min-height (Panel height setting) if this never runs.
 */
(function () {
  'use strict';

  function fit() {
    var footer = document.querySelector('.coil-footer');
    if (!footer) return;

    var header = document.querySelector('.shopify-section-group-header-group');
    var headerH = header ? header.getBoundingClientRect().height : 0;

    // Never collapse below a sane floor.
    footer.style.minHeight = Math.max(window.innerHeight - headerH, 260) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fit);
  } else {
    fit();
  }
  // Re-fit after load (layout settles) and on resize.
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit, { passive: true });
})();
